import { useState } from 'react';
import { ref, deleteObject } from 'firebase/storage';
import { doc, getDocs, collection, deleteDoc } from 'firebase/firestore';

const DeleteRes = (props) => {

    const [verification, setVerification] = useState("");

    const deleteThis = async () => {
        // borrar fotos principales
        let currentRef = ref(props.storage, `Restaurants/${props.id}/${props.data.frontPic}`);
        deleteObject(currentRef).catch((error) => {
            console.log("Error deleting, doesn't exists?");
        });

        currentRef = ref(props.storage, `Restaurants/${props.id}/${props.data.cover}`);
        deleteObject(currentRef).catch((error) => {
            console.log("Error deleting, doesn't exists?");
        });

        currentRef = ref(props.storage, `Restaurants/${props.id}/${props.data.logo}`);
        deleteObject(currentRef).catch((error) => {
            console.log("Error deleting, doesn't exists?");
        });

        // Delete Dishes
        getDocs(collection(props.eDB, 'Restaurants', props.id, 'Dishes'))
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {

                //Delete Dish Comments
                getDocs(collection(props.eDB, 'Restaurants', props.id, 'Dishes', doc.id, 'Comments'))
                .then((querySnapshot) => {
                    querySnapshot.forEach((comment) => {
                        const dish = doc.data();
                        deleteDoc(comment.ref);
                    });
                });

                // Delete Dish Picture
                const dish = doc.data();
                currentRef = ref(props.storage, `Restaurants/${props.id}/MenuPictures/${dish.picture}`);

                deleteObject(currentRef).catch((error) => {
                    console.log("Error deleting, doesn't exists?");
                });

                //Delete Dish Itself
                deleteDoc(doc.ref);
            });
        });

        // Delete Contacts
        getDocs(collection(props.eDB, 'Restaurants', props.id, 'Contacts'))
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                //Delete Dish Itself
                deleteDoc(doc.ref);
            });
        });

        // Delete Schedules
        getDocs(collection(props.eDB, 'Restaurants', props.id, 'Schedules'))
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                //Delete Dish Itself
                deleteDoc(doc.ref);
            });
        });

        // Delete Menu
        getDocs(collection(props.eDB, 'Restaurants', props.id, 'Menu'))
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                //Delete Dish Itself
                deleteDoc(doc.ref);
            });
        });

        //Delete Restaurant Itself
        const menuRef = doc(props.eDB, `Restaurants/${props.id}`);
        deleteDoc(menuRef);

        props.close();
    }

    return <div style={{maxWidth: '500px'}}>
        <p style={{color: 'black'}} className='tx-black'>Estas a punto de borrar <strong>{props.data.name}</strong>, esto eliminara los contactos, horarios, platillos y fotos relacionadas. Tambien borrara todos los <strong>comentarios de los usuarios</strong> y no podran ser recuperados.</p>
        <p style={{color: 'black'}}>Escribe el nombre del restaurante para confirmar</p>

        <div className='d-flex'>
            <input className='m-auto' type='text' placeholder={props.data.name} value={verification} onChange={(e) => setVerification(e.target.value)} />
        </div>

        <div className="mt-2">
            <button className={verification==props.data.name?'m-auto btn btn-cancel':'m-auto btn'} onClick={deleteThis} disabled={verification!==props.data.name}>Borrar</button>
        </div>  
    </div>;
}

export default DeleteRes